module.exports = __webpack_public_path__ + "img/revxy_fullLogo_fullWhite_NOsubtitle.b5c6572e.svg";